module.exports = __webpack_public_path__ + "img/strategie-edpd.e89b1a71.jpg";